module.exports = __webpack_public_path__ + "media/images/image1-615ee176240e26dec57374c367c8e19d.png";